module.exports = __webpack_public_path__ + "img/illu_token_03.32d4f7e3.svg";